<template>
    <div>
        <h5>Manage Users Group</h5>
        <div class="card">
            <!-- Dropdown for groups listing -->
            <div class="field col-3">
                <UsersPicker label="Select a User" v-model="selectedUserId" />
                <small class="p-invalid" v-if="submitted && !selectedUserId">Select atleast one user from the dropdown.</small>
            </div>
            <div v-if="selectedUserId">
                <div class="field col-12">
                    <label for="description">Select Groups for the User</label>
                    <br />
                    <small class="p-invalid" v-if="submitted && groupsSource[1].length <= 0">Select atleast one group from the list.</small>
                    <PickList v-model="groupsSource" dataKey="id" :showSourceControls="false" :showTargetControls="false">
                        <template #sourceheader> {{ groupsSource[0].length }} Groups Available </template>
                        <template #targetheader> Added Group List </template>
                        <template #item="{ item }">ID: {{ item.id }} <label class="ml-2">{{ item.code }}</label></template>
                    </PickList>
                </div>
                <div class="field flex justify-content-center">
                    <Button label="Save" class="my-2" @click="addGroupsToUser"></Button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import UsersPicker from '@/modules/user/components/UsersPicker.vue';

import { ref, onMounted, watch } from 'vue';
import { userStore, groupStore } from '../../../store/global-stores';
import { storeToRefs } from 'pinia';

const { userGroups } = storeToRefs(userStore);
const { groups } = storeToRefs(groupStore);

const selectedUserId = ref(null);
const groupsSource = ref([]);
const submitted = ref(false);

watch(selectedUserId, () => {
    if (selectedUserId.value) {
        loadUserGroup(selectedUserId.value);
    }
});

onMounted(async () => {
    // fetch all existing groups from the db
    const paginate = false;
    await groupStore.getAllGroups({}, paginate);
});

// loads the user groupSource for the picklist component
const loadUserGroup = async (userId) => {
    // first load all groups into the groupsSource
    groupsSource.value[0] = groups.value;
    // fetch the permission group which user has access
    await userStore.fetchUserPermissionGroups(userId);
    /** After loading the user existing groups load them accordingly*/
    groupsSource.value[1] = userGroups.value;
    // now filter them from groupSource.value[0]
    groupsSource.value[0] = filterExistingUserGroups();
};

// this function filters out the list of array that already exists in second array from first array
const filterExistingUserGroups = () => {
    let arr1 = groupsSource.value[0];
    let arr2 = groupsSource.value[1];
    return arr1.filter((obj1) => !arr2.find((obj2) => obj1.id === obj2.id));
};

const addGroupsToUser = async () => {
    submitted.value = true;
    if (isValid()) {
        const groupIds = groupsSource.value[1]?.map((group) => group.id);
        const updated = await userStore.setUserPermissionGroups(selectedUserId.value, groupIds);
        if (updated) {
            selectedUserId.value = null;
            groupsSource.value = [];
            submitted.value = false;
        }
    }
};

const isValid = () => {
    if (!selectedUserId.value || groupsSource.value[1]?.length <= 0) {
        return false;
    }
    return true;
};
</script>

<style>
.p-picklist-source-controls,
.p-picklist-target-controls {
    display: none;
}
</style>
